<template>
  <div>
    <div class="self-tabs">
      <!-- <a-tabs defaultActiveKey="1" @change="callback"> -->
      <!-- <a-tab-pane tab="密码登录" key="1" forceRender> -->
      <div :class="['login-box__wrapper', tel_error ? 'err-focus' : '']">
        <input
          @focus="getFocus"
          @blur="removeFocus"
          type="text"
          name="tell"
          class="login-input login-input_big"
          placeholder="输入手机号"
          v-model="tel"
        />
        <span class="hint errright">{{ tel_error }}</span>
      </div>
      <div :class="['login-box__wrapper', 'clearfix', password_error ? 'err-focus' : '']">
        <input
          @focus="getFocus"
          @blur="removeFocus"
          v-model="psw"
          :type="show ? 'text' : 'password'"
          class="login-input login-input_big fl"
          placeholder="输入密码"
        />
        <span class="hint errcenter">{{ password_error }} </span>
        <div :class="['login-svg', show ? 'show' : '']" alt="" @click="changeEye"></div>
      </div>
      <!-- 添加图形验证码 -->

      <div
        v-if="this.$store.state.need_captcha"
        :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']"
      >
        <input
          @focus="getFocus"
          @blur="removeFocus"
          v-model="captcha"
          class="login-input login-input_min fl"
          placeholder="输入验证码"
        />
        <span class="hint errright">{{ code_error }} </span>
      </div>
      <div
        style="text-align: center;"
        class="login-btn__wrapper clearfix"
        v-if="this.$store.state.need_captcha"
      >
        <ImgCode :src="imgCodeSrc" @get_new_img="getNewImageCode"></ImgCode>
      </div>
      <!-- <div style="text-align: center;" class="login-btn__wrapper clearfix" v-if="request_error">
        <span class="error-info">获取验证码失败，请稍后再试</span>
      </div> -->
      <!-- </a-tab-pane> -->
      <!-- <a-tab-pane tab="验证码登录" key="2">
          <div :class="['login-box__wrapper', tel_error ? 'err-focus' : '']">
            <input
              @focus="getFocus"
              @blur="removeFocus"
              type="text"
              id="tell2"
              class="login-input login-input_big"
              placeholder="请输入手机号"
              v-model="tel"
            />
            <span class="hint errright">{{ tel_error }}</span>
          </div>
          <div :class="['login-box__wrapper', 'clearfix', code_error ? 'err-focus' : '']">
            <input
              v-model="code"
              @focus="getFocus"
              @blur="removeFocus"
              type="text"
              class="login-input login-input_big login-input_left login-input_psw fl"
              placeholder="验证码"
            />
            <span class="hint errcenter">{{ code_error }} </span>
            <countBtn
              :clean="clean"
              @result="resultHandler"
              class="modal-count"
              :value="tel"
            ></countBtn>
          </div>
        </a-tab-pane> -->
      <!-- </a-tabs> -->
    </div>
    <div class="login-btn__wrapper clearfix">
      <a-button
        :disabled="!validBind"
        :class="['login-btn', 'login-btn_big', validBind ? 'active-login' : 'disable']"
        :loading="loading"
        @click="enroll"
      >
        登录
      </a-button>
    </div>
    <div class="login-box__handle clearfix left">
      <a-checkbox class="fl" @change="remember_me = !remember_me" :checked="remember_me"
        >下次自动登录</a-checkbox
      >

      <a class="fr" style="font-size:12px" href="javascript:void(0)" @click="goEnroll">注册账号</a>
      <a class="fr" href="javascript:void" style="padding: 0px 10px;">|</a>
      <a class="fr" style="font-size:12px" target="_blank" href="/search/personal/modify-info"
        >忘记密码</a
      >
    </div>
  </div>
</template>
<script>
import { getUserInfo } from '@/apps/personal/models/api'
import { api_post, api_get } from '@/utils/http.ts'
import sha256 from 'js-sha256'
import { loadFromLocal, saveToLocal } from '@/utils/local'
import { http_withoutcookie } from '@/utils/http.ts'
import enrollMixin from './enrollMixin.js'
import ImgCode from '@/components/enroll/ImgCode.vue'
export default {
  name: 'LoginTpl',
  mixins: [enrollMixin],
  data() {
    return {
      tel: '',
      captcha: '',
      request_error: '',
      imgCodeSrc: '',
      act_key: '1',
      remember_me: false,
      loading: false
    }
  },
  methods: {
    getNewImageCode() {
      this.imgCodeSrc = this.imgCodeSrc + '&s=' + Math.random()
    },
    goEnroll() {
      this.clearLogin()
      this.$emit('go_enroll')
    },
    callback(key) {
      this.act_key = key
      if (key == '1') {
        this.code = ''
      } else {
        this.psw = ''
      }
    },
    async enroll() {
      let postd = {
        username: this.tel,
        // code: this.code,
        // captcha: this.captcha,
        password: this.psw,
        // password: this.psw ? sha256(this.psw) : '',
        remember_me: this.remember_me
      }
      this.loading = true
      if (this.$store.state.need_captcha) {
        postd.captcha = this.captcha
      }
      let rdata = await http_withoutcookie('/search/api/auth/login', postd)
      this.loading = false
      if (rdata.success) {
        //store
        if (typeof rdata.data != 'undefined') {
          let name = rdata.data.username
          if (!name) {
            return
          }

          saveToLocal('net_username', name)
          this.$store.commit('SET_USER_INFO', rdata.data)
          this.$store.commit('SET_USER', { name: name })
          this.$sa.login(rdata.data.phone)
          this.$emit('on_cancel')
          let flag = rdata.data.coupon || false
          this.$store.commit('SET_USER_VERIFY', false)
          // 调整emit时机
          this.$emit('login_success', flag)
        }
      } else {
        if (rdata.need_captcha) {
          // this.need_captcha = true
          this.$store.commit('SET_USER_VERIFY', true)
          if (this.password_error && this.captcha) return
          this.imgCodeSrc =
            window.location.origin + '/search/api/auth/cmine_captcha?username=' + this.tel
        }

        if (rdata.code_error === '请输入正确的验证码') {
          this.$store.commit('SET_USER_VERIFY', true)
          this.imgCodeSrc =
            window.location.origin + '/search/api/auth/cmine_captcha?username=' + this.tel
        }
        this.showError(rdata)
      }
    }
  },
  computed: {
    // normalenv: function() {
    //   return /17zuoye.com/.test(window.location.host)
    // },
    validBind: function() {
      return (
        (this.act_key == 2 && this.tel !== '' && this.code != '') ||
        (this.act_key == 1 && this.tel !== '' && this.psw != '')
      )
    },
    position() {
      return location.pathname + location.search || ''
    }
  },
  components: { ImgCode },
  watch: {
    tel: function(val) {
      if (val) {
        // this.imgCodeSrc = window.location.origin + '/search/api/auth/cmine_captcha?username=' + val
      }
    },
    clean: function(val) {
      if (!val) {
        this.clearLogin()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.self-tabs {
  text-align: center;
}
</style>
